import React, { useEffect, useState } from 'react';

export default function RatingDisplay({ attributes, rowId, colId, setValue }) {
  const [selected, setSelected] = useState(attributes.value != null ? Number(attributes.value) : null);

  useEffect(() => {
    setValue((oldValue) => {
      const newValue = [...oldValue];
      newValue[rowId].cols[colId].attributes.value = selected;
      newValue[rowId].cols[colId].attributes.errorMessage =
        !selected && attributes.required ? 'Selecione uma nota' : '';
      return newValue;
    });
  }, [selected, setValue, rowId, colId, attributes.required]);

  return (
    <div className="custom-input-container">
      <div className="displayed-label">
        <span>{attributes.ask}{attributes.required && '*'}</span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px' }}>
        {[...Array(10)].map((_, i) => {
          const val = i + 1;
          const isSelected = selected === val;
          return (
            <button
              key={val}
              type="button"
              onClick={() => setSelected(val)}
              style={{
                width: '36px',
                height: '36px',
                border: `1px solid ${isSelected ? '#0d6efd' : '#6c757d'}`,
                borderRadius: '4px',
                background: isSelected ? '#0d6efd' : '#fff',
                color: isSelected ? '#fff' : '#212529',
                fontSize: '14px',
                fontWeight: isSelected ? 'bold' : 'normal',
                cursor: 'pointer',
              }}
            >
              {val}
            </button>
          );
        })}
      </div>
    </div>
  );
}
